import _definePage_default_0 from '/home/appforge/public_html/resources/ts/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/appforge/public_html/resources/ts/pages/apps/wordpress/index.vue?definePage&vue'
import _definePage_default_3 from '/home/appforge/public_html/resources/ts/pages/blog/index.vue?definePage&vue'
import _definePage_default_4 from '/home/appforge/public_html/resources/ts/pages/blog/[slug].vue?definePage&vue'
import _definePage_default_5 from '/home/appforge/public_html/resources/ts/pages/changelog/index.vue?definePage&vue'
import _definePage_default_6 from '/home/appforge/public_html/resources/ts/pages/developers/api.vue?definePage&vue'
import _definePage_default_7 from '/home/appforge/public_html/resources/ts/pages/forgot-password.vue?definePage&vue'
import _definePage_default_8 from '/home/appforge/public_html/resources/ts/pages/landing.vue?definePage&vue'
import _definePage_default_9 from '/home/appforge/public_html/resources/ts/pages/lead/[appId]/[slug].vue?definePage&vue'
import _definePage_default_10 from '/home/appforge/public_html/resources/ts/pages/legal/[appId]/[type].vue?definePage&vue'
import _definePage_default_11 from '/home/appforge/public_html/resources/ts/pages/legal/platform/[type].vue?definePage&vue'
import _definePage_default_12 from '/home/appforge/public_html/resources/ts/pages/login.vue?definePage&vue'
import _definePage_default_13 from '/home/appforge/public_html/resources/ts/pages/modules/[slug].vue?definePage&vue'
import _definePage_default_14 from '/home/appforge/public_html/resources/ts/pages/newsletter/unsubscribe/[token].vue?definePage&vue'
import _definePage_default_15 from '/home/appforge/public_html/resources/ts/pages/not-authorized.vue?definePage&vue'
import _definePage_default_16 from '/home/appforge/public_html/resources/ts/pages/pages/account-settings/[tab].vue?definePage&vue'
import _definePage_default_17 from '/home/appforge/public_html/resources/ts/pages/pages/authentication/reset-password-v1.vue?definePage&vue'
import _definePage_default_18 from '/home/appforge/public_html/resources/ts/pages/prezzi.vue?definePage&vue'
import _definePage_default_19 from '/home/appforge/public_html/resources/ts/pages/register.vue?definePage&vue'
import _definePage_default_20 from '/home/appforge/public_html/resources/ts/pages/soluzioni/[slug].vue?definePage&vue'
import _definePage_default_21 from '/home/appforge/public_html/resources/ts/pages/under-maintenance.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/appforge/public_html/resources/ts/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
      {
        path: 'apps',
        name: 'admin-apps',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/apps.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-apps",
          "layout": "default"
        }
      },
      {
        path: 'billing-settings',
        name: 'admin-billing-settings',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/billing-settings.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-billing-settings"
        }
      },
      {
        path: 'blog',
        /* internal name: 'admin-blog' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-blog',
            component: () => import('/home/appforge/public_html/resources/ts/pages/admin/blog/index.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "admin",
              "navActiveLink": "admin-blog",
              "layout": "default"
            }
          },
          {
            path: ':id',
            /* internal name: 'admin-blog-id' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: 'admin-blog-id-edit',
                component: () => import('/home/appforge/public_html/resources/ts/pages/admin/blog/[id]/edit.vue'),
                /* no children */
                meta: {
                  "action": "read",
                  "subject": "admin",
                  "navActiveLink": "admin-blog",
                  "layout": "default"
                }
              }
            ],
          },
          {
            path: 'add',
            name: 'admin-blog-add',
            component: () => import('/home/appforge/public_html/resources/ts/pages/admin/blog/add.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "admin",
              "navActiveLink": "admin-blog",
              "layout": "default"
            }
          }
        ],
      },
      {
        path: 'changelog',
        /* internal name: 'admin-changelog' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-changelog',
            component: () => import('/home/appforge/public_html/resources/ts/pages/admin/changelog/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'clients',
        name: 'admin-clients',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/clients.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-clients"
        }
      },
      {
        path: 'communications',
        name: 'admin-communications',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/communications.vue'),
        /* no children */
      },
      {
        path: 'cron',
        name: 'admin-cron',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/cron.vue'),
        /* no children */
      },
      {
        path: 'custom-domains',
        name: 'admin-custom-domains',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/custom-domains.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-custom-domains",
          "layout": "default"
        }
      },
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/dashboard.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-dashboard",
          "layout": "default"
        }
      },
      {
        path: 'features',
        name: 'admin-tenant-features',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/features.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-tenant-features",
          "layout": "default"
        }
      },
      {
        path: 'invoices',
        name: 'admin-invoices',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/invoices.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-invoices"
        }
      },
      {
        path: 'languages',
        /* internal name: 'admin-languages' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-languages',
            component: () => import('/home/appforge/public_html/resources/ts/pages/admin/languages/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'admin-languages-id',
            component: () => import('/home/appforge/public_html/resources/ts/pages/admin/languages/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'notification-logs',
        name: 'admin-notification-logs',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/notification-logs.vue'),
        /* no children */
      },
      {
        path: 'notification-templates',
        name: 'admin-notification-templates',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/notification-templates.vue'),
        /* no children */
        meta: {
          "action": "read",
          "subject": "admin",
          "navActiveLink": "admin-notification-templates",
          "layout": "default"
        }
      },
      {
        path: 'settings',
        name: 'admin-settings',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/settings.vue'),
        children: [
          {
            path: 'general',
            name: 'admin-settings-general',
            component: () => import('/home/appforge/public_html/resources/ts/pages/admin/settings/general.vue'),
            /* no children */
            meta: {
              "navActiveLink": "admin-settings-general",
              "layout": "default"
            }
          },
          {
            path: 'legal',
            name: 'admin-settings-legal',
            component: () => import('/home/appforge/public_html/resources/ts/pages/admin/settings/legal.vue'),
            /* no children */
          }
        ],
        meta: {
          "navActiveLink": "admin-settings",
          "layout": "default"
        }
      },
      {
        path: 'smtp',
        name: 'admin-smtp',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/smtp.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-smtp",
          "layout": "default"
        }
      },
      {
        path: 'stripe-settings',
        name: 'admin-stripe-settings',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/stripe-settings.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-stripe-settings",
          "layout": "default",
          "action": "read",
          "subject": "admin"
        }
      },
      {
        path: 'subscription-plans',
        name: 'admin-subscription-plans',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/subscription-plans.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-subscription-plans",
          "layout": "default"
        }
      },
      {
        path: 'subscriptions',
        name: 'admin-subscriptions',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/subscriptions.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-subscriptions"
        }
      },
      {
        path: 'system-settings',
        name: 'admin-system-settings',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/system-settings.vue'),
        /* no children */
      },
      {
        path: 'tenant-features',
        name: 'admin-features',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/tenant-features.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-features",
          "layout": "default"
        }
      },
      {
        path: 'tenant-whitelabel',
        name: 'admin-tenant-whitelabel',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/tenant-whitelabel.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-tenant-whitelabel",
          "layout": "default"
        }
      },
      {
        path: 'tenants',
        name: 'admin-tenants',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/tenants.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-tenants",
          "layout": "default"
        }
      },
      {
        path: 'whatsender',
        name: 'admin-whatsender',
        component: () => import('/home/appforge/public_html/resources/ts/pages/admin/whatsender.vue'),
        /* no children */
        meta: {
          "navActiveLink": "admin-whatsender",
          "layout": "default"
        }
      }
    ],
  },
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'attendance',
        /* internal name: 'apps-attendance' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-attendance-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/attendance/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-attendance-settings",
              "layout": "default",
              "action": "read",
              "subject": "attendance"
            }
          }
        ],
      },
      {
        path: 'book-catalog',
        /* internal name: 'apps-book-catalog' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-book-catalog-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/book-catalog/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-book-catalog-settings",
              "layout": "default",
              "action": "read",
              "subject": "book_catalog"
            }
          }
        ],
      },
      {
        path: 'communications-hub',
        /* internal name: 'apps-communications-hub' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-communications-hub-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/communications-hub/settings.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "communications_hub"
            }
          }
        ],
      },
      {
        path: 'community-hub',
        /* internal name: 'apps-community-hub' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-community-hub-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/community-hub/settings.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "community_hub"
            }
          }
        ],
      },
      {
        path: 'coupon-rush',
        /* internal name: 'apps-coupon-rush' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-coupon-rush-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/coupon-rush/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-coupon-rush-settings",
              "layout": "default",
              "action": "read",
              "subject": "coupon_rush"
            }
          }
        ],
      },
      {
        path: 'custom-html',
        /* internal name: 'apps-custom-html' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-custom-html-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/custom-html/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-custom-html-settings",
              "layout": "default",
              "action": "read",
              "subject": "custom_html"
            }
          }
        ],
      },
      {
        path: 'custom-page',
        /* internal name: 'apps-custom-page' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-custom-page-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/custom-page/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-custom-page-settings",
              "layout": "default",
              "action": "read",
              "subject": "custom_page"
            }
          }
        ],
      },
      {
        path: 'customer-groups',
        /* internal name: 'apps-customer-groups' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-customer-groups',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/customer-groups/index.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "customers"
            }
          }
        ],
      },
      {
        path: 'digital-signage',
        /* internal name: 'apps-digital-signage' */
        /* no component */
        children: [
          {
            path: 'displays',
            /* internal name: 'apps-digital-signage-displays' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-digital-signage-displays',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/digital-signage/displays/index.vue'),
                /* no children */
                meta: {
                  "navActiveLink": "apps-digital-signage-displays"
                }
              },
              {
                path: ':id',
                name: 'apps-digital-signage-displays-id',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/digital-signage/displays/[id].vue'),
                /* no children */
                meta: {
                  "navActiveLink": "apps-digital-signage-displays"
                }
              },
              {
                path: 'DigitalSignageLivePreviewZone',
                name: 'apps-digital-signage-displays-digital-signage-live-preview-zone',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/digital-signage/displays/DigitalSignageLivePreviewZone.vue'),
                /* no children */
              },
              {
                path: 'DigitalSignageZonePlaylistDialog',
                name: 'apps-digital-signage-displays-digital-signage-zone-playlist-dialog',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/digital-signage/displays/DigitalSignageZonePlaylistDialog.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'ecommerce',
        /* internal name: 'apps-ecommerce' */
        /* no component */
        children: [
          {
            path: 'inventory',
            /* internal name: 'apps-ecommerce-inventory' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-ecommerce-inventory',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/inventory/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'manage-review',
            name: 'apps-ecommerce-manage-review',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/manage-review.vue'),
            /* no children */
          },
          {
            path: 'order',
            /* internal name: 'apps-ecommerce-order' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-order-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-order-details-id',
                    component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/order/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-order-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-order-list',
                    component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/order/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'product',
            /* internal name: 'apps-ecommerce-product' */
            /* no component */
            children: [
              {
                path: 'add',
                /* internal name: 'apps-ecommerce-product-add' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-add',
                    component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/product/add/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'category-list',
                name: 'apps-ecommerce-categories',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/product/category-list.vue'),
                /* no children */
                meta: {
                  "action": "read",
                  "subject": "ecommerce",
                  "layout": "default"
                }
              },
              {
                path: 'edit',
                /* internal name: 'apps-ecommerce-product-edit' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-product-edit-id',
                    component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/product/edit/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-product-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-list',
                    component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/product/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'report',
            /* internal name: 'apps-ecommerce-report' */
            /* no component */
            children: [
              {
                path: 'sales',
                name: 'apps-ecommerce-report-sales',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/report/sales.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'settings',
            name: 'apps-ecommerce-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ecommerce/settings.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'folder',
        /* internal name: 'apps-folder' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-folder',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/folder/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'apps-folder-id',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/folder/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'forms',
        /* internal name: 'apps-forms' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-forms',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/forms/index.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "forms"
            }
          },
          {
            path: 'builder',
            /* internal name: 'apps-forms-builder' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-forms-builder-id',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/forms/builder/[id].vue'),
                /* no children */
                meta: {
                  "action": "read",
                  "subject": "forms",
                  "navActiveLink": "apps-forms"
                }
              }
            ],
          },
          {
            path: 'requests',
            name: 'apps-forms-requests',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/forms/requests.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "forms",
              "navActiveLink": "apps-forms"
            }
          },
          {
            path: 'submissions',
            /* internal name: 'apps-forms-submissions' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-forms-submissions-id',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/forms/submissions/[id].vue'),
                /* no children */
                meta: {
                  "action": "read",
                  "subject": "forms",
                  "navActiveLink": "apps-forms"
                }
              }
            ],
          }
        ],
      },
      {
        path: 'funnel',
        /* internal name: 'apps-funnel' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-funnel',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/funnel/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'apps-funnel-id',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/funnel/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'gallery',
        /* internal name: 'apps-gallery' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-gallery',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/gallery/index.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-gallery"
            }
          },
          {
            path: ':id',
            name: 'apps-gallery-id',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/gallery/[id].vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-gallery"
            }
          }
        ],
      },
      {
        path: 'games',
        /* internal name: 'apps-games' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-games-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/games/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-games-settings",
              "layout": "default",
              "action": "read",
              "subject": "games"
            }
          }
        ],
      },
      {
        path: 'languages',
        /* internal name: 'apps-languages' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-languages',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/languages/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'apps-languages-id',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/languages/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'loyalty-card',
        /* internal name: 'apps-loyalty-card' */
        /* no component */
        children: [
          {
            path: 'cashiers',
            name: 'apps-loyalty-card-cashiers',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/loyalty-card/cashiers.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-loyalty-card-cashiers",
              "action": "manage",
              "subject": "loyalty_card"
            }
          },
          {
            path: 'pos',
            name: 'apps-loyalty-card-pos',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/loyalty-card/pos.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-loyalty-card-pos",
              "layout": "default",
              "action": "manage",
              "subject": "loyalty_card"
            }
          },
          {
            path: 'pos-cashier',
            name: 'apps-loyalty-card-pos-cashier',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/loyalty-card/pos-cashier.vue'),
            /* no children */
            meta: {
              "layout": "blank",
              "action": "manage",
              "subject": "loyalty_card"
            }
          },
          {
            path: 'rewards',
            name: 'apps-loyalty-card-rewards',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/loyalty-card/rewards.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-loyalty-card-rewards",
              "layout": "default",
              "action": "read",
              "subject": "loyalty_card"
            }
          },
          {
            path: 'settings',
            name: 'apps-loyalty-card-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/loyalty-card/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-loyalty-card-settings",
              "layout": "default",
              "action": "read",
              "subject": "loyalty_card"
            }
          },
          {
            path: 'users',
            name: 'apps-loyalty-card-users',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/loyalty-card/users.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'notifications',
        /* internal name: 'apps-notifications' */
        /* no component */
        children: [
          {
            path: 'logs',
            name: 'apps-notifications-logs',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/notifications/logs.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "notifications",
              "layout": "default"
            }
          },
          {
            path: 'reminders',
            name: 'apps-notifications-reminders',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/notifications/reminders.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "notifications",
              "layout": "default"
            }
          },
          {
            path: 'send',
            name: 'apps-notifications-send',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/notifications/send.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "notifications",
              "layout": "default"
            }
          },
          {
            path: 'templates',
            name: 'apps-notifications-templates',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/notifications/templates.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "notifications",
              "layout": "default"
            }
          }
        ],
      },
      {
        path: 'nutritionist',
        /* internal name: 'apps-nutritionist' */
        /* no component */
        children: [
          {
            path: 'diets',
            name: 'apps-nutritionist-diets',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/nutritionist/diets.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "roles": [
                "admin"
              ],
              "subject": "nutritionist"
            }
          },
          {
            path: 'profiles',
            name: 'apps-nutritionist-profiles',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/nutritionist/profiles.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "roles": [
                "admin"
              ],
              "subject": "nutritionist"
            }
          },
          {
            path: 'settings',
            name: 'apps-nutritionist-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/nutritionist/settings.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "roles": [
                "admin"
              ],
              "subject": "nutritionist"
            }
          }
        ],
      },
      {
        path: 'popup',
        /* internal name: 'apps-popup' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-popup-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/popup/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-popup-settings",
              "layout": "default",
              "action": "read",
              "subject": "popup"
            }
          }
        ],
      },
      {
        path: 'profinder',
        /* internal name: 'apps-profinder' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-profinder-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/profinder/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-profinder-settings",
              "layout": "default",
              "action": "read",
              "subject": "profinder"
            }
          }
        ],
      },
      {
        path: 'promo-coupon',
        /* internal name: 'apps-promo-coupon' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-promo-coupon',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/promo-coupon/index.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-promo-coupon",
              "layout": "default",
              "action": "read",
              "subject": "promo_coupon"
            }
          }
        ],
      },
      {
        path: 'radio',
        /* internal name: 'apps-radio' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-radio-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/radio/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-radio-settings",
              "layout": "default",
              "action": "read",
              "subject": "radio"
            }
          }
        ],
      },
      {
        path: 'referral',
        /* internal name: 'apps-referral' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-referral',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/referral/index.vue'),
            /* no children */
          },
          {
            path: 'settings',
            name: 'apps-referral-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/referral/settings.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'ride-hailing',
        /* internal name: 'apps-ride-hailing' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-ride-hailing-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/ride-hailing/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-ride-hailing-settings",
              "layout": "default",
              "action": "read",
              "subject": "ride_hailing"
            }
          }
        ],
      },
      {
        path: 'salon',
        /* internal name: 'apps-salon' */
        /* no component */
        children: [
          {
            path: 'bookings',
            name: 'apps-salon-bookings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/bookings.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon_booking",
              "layout": "default",
              "navActiveLink": "apps-salon-bookings"
            }
          },
          {
            path: 'branches',
            name: 'apps-salon-branches',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/branches.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon",
              "layout": "default"
            }
          },
          {
            path: 'categories',
            name: 'apps-salon-categories',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/categories.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon",
              "layout": "default"
            }
          },
          {
            path: 'employees',
            name: 'apps-salon-employees',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/employees.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon",
              "layout": "default"
            }
          },
          {
            path: 'packages',
            name: 'apps-salon-packages',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/packages.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon",
              "layout": "default"
            }
          },
          {
            path: 'portfolio',
            name: 'apps-salon-portfolio',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/portfolio.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon_booking",
              "layout": "default"
            }
          },
          {
            path: 'resources',
            name: 'apps-salon-resources',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/resources.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon",
              "layout": "default"
            }
          },
          {
            path: 'reviews',
            name: 'apps-salon-reviews',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/reviews.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon",
              "layout": "default"
            }
          },
          {
            path: 'schedules',
            name: 'apps-salon-schedules',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/schedules.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon",
              "layout": "default"
            }
          },
          {
            path: 'services',
            name: 'apps-salon-services',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/services.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon",
              "layout": "default"
            }
          },
          {
            path: 'settings',
            name: 'apps-salon-booking-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-salon-booking-settings",
              "layout": "default",
              "action": "read",
              "subject": "salon_booking"
            }
          },
          {
            path: 'waitlists',
            name: 'apps-salon-waitlists',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/salon/waitlists.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "salon",
              "layout": "default"
            }
          }
        ],
      },
      {
        path: 'scratch-win',
        /* internal name: 'apps-scratch-win' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-scratch-win-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/scratch-win/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-scratch-win-settings",
              "layout": "default",
              "action": "read",
              "subject": "scratch_win"
            }
          }
        ],
      },
      {
        path: 'shared-documents',
        /* internal name: 'apps-shared-documents' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-shared-documents',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/shared-documents/index.vue'),
            /* no children */
            meta: {
              "action": "read",
              "subject": "shared_documents"
            }
          }
        ],
      },
      {
        path: 'shopify-sync',
        /* internal name: 'apps-shopify-sync' */
        /* no component */
        children: [
          {
            path: 'settings',
            name: 'apps-shopify-sync-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/shopify-sync/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-shopify-sync-settings",
              "layout": "default",
              "action": "read",
              "subject": "shopify_sync"
            }
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/user/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'view',
            /* internal name: 'apps-user-view' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-user-view-id',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/user/view/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'webview',
        /* internal name: 'apps-webview' */
        /* no component */
        children: [
          {
            path: 'groups',
            name: 'apps-webview-groups',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/webview/groups.vue'),
            /* no children */
          },
          {
            path: 'list',
            name: 'apps-webview-list',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/webview/list.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'wordpress',
        /* internal name: 'apps-wordpress' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-wordpress',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/wordpress/index.vue'),
            /* no children */
          },
  _definePage_default_2
  )
        ],
      },
      {
        path: 'xdelivery',
        /* internal name: 'apps-xdelivery' */
        /* no component */
        children: [
          {
            path: 'addon-categories',
            name: 'apps-xdelivery-addon-categories',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/addon-categories.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-addon-categories"
            }
          },
          {
            path: 'categories',
            name: 'apps-xdelivery-categories',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/categories.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-categories"
            }
          },
          {
            path: 'delivery-zones',
            name: 'apps-xdelivery-delivery-zones',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/delivery-zones.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-delivery-zones"
            }
          },
          {
            path: 'locations',
            name: 'apps-xdelivery-locations',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/locations.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-locations"
            }
          },
          {
            path: 'menu',
            name: 'apps-xdelivery-menu',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/menu.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-menu"
            }
          },
          {
            path: 'orders',
            name: 'apps-xdelivery-orders',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/orders.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-orders"
            }
          },
          {
            path: 'pos',
            name: 'apps-xdelivery-pos',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/pos.vue'),
            /* no children */
            meta: {
              "layout": "blank"
            }
          },
          {
            path: 'print-bridges',
            name: 'apps-xdelivery-print-bridges',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/print-bridges.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-print-bridges"
            }
          },
          {
            path: 'report',
            /* internal name: 'apps-xdelivery-report' */
            /* no component */
            children: [
              {
                path: 'sales',
                name: 'apps-xdelivery-report-sales',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/report/sales.vue'),
                /* no children */
                meta: {
                  "navActiveLink": "apps-xdelivery-report-sales"
                }
              }
            ],
          },
          {
            path: 'reservations',
            name: 'apps-xdelivery-reservations',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/reservations.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-reservations"
            }
          },
          {
            path: 'rooms',
            /* internal name: 'apps-xdelivery-rooms' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-xdelivery-rooms',
                component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/rooms/index.vue'),
                /* no children */
                meta: {
                  "navActiveLink": "apps-xdelivery-rooms"
                }
              },
              {
                path: 'map',
                /* internal name: 'apps-xdelivery-rooms-map' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-xdelivery-rooms-map-id',
                    component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/rooms/map/[id].vue'),
                    /* no children */
                    meta: {
                      "navActiveLink": "apps-xdelivery-rooms"
                    }
                  }
                ],
              }
            ],
          },
          {
            path: 'schedules',
            name: 'apps-xdelivery-schedules',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/schedules.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-schedules"
            }
          },
          {
            path: 'settings',
            name: 'apps-xdelivery-settings',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/settings.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-settings"
            }
          },
          {
            path: 'staff',
            name: 'apps-xdelivery-staff',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/staff.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-staff"
            }
          },
          {
            path: 'tables',
            name: 'apps-xdelivery-tables',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/tables.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-tables"
            }
          },
          {
            path: 'ticket-template',
            name: 'apps-xdelivery-ticket-template',
            component: () => import('/home/appforge/public_html/resources/ts/pages/apps/xdelivery/ticket-template.vue'),
            /* no children */
            meta: {
              "navActiveLink": "apps-xdelivery-ticket-template"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/blog',
    /* internal name: 'blog' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'blog',
        component: () => import('/home/appforge/public_html/resources/ts/pages/blog/index.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: ':slug',
        name: 'blog-slug',
        component: () => import('/home/appforge/public_html/resources/ts/pages/blog/[slug].vue'),
        /* no children */
      },
  _definePage_default_4
  )
    ],
  },
  {
    path: '/changelog',
    /* internal name: 'changelog' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'changelog',
        component: () => import('/home/appforge/public_html/resources/ts/pages/changelog/index.vue'),
        /* no children */
      },
  _definePage_default_5
  )
    ],
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
      {
        path: 'tenant',
        name: 'tenant-dashboard',
        component: () => import('/home/appforge/public_html/resources/ts/pages/dashboards/tenant.vue'),
        /* no children */
        meta: {
          "layout": "default"
        }
      }
    ],
  },
  {
    path: '/developers',
    /* internal name: 'developers' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'api',
        name: 'developers-api',
        component: () => import('/home/appforge/public_html/resources/ts/pages/developers/api.vue'),
        /* no children */
      },
  _definePage_default_6
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/home/appforge/public_html/resources/ts/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_7
  ),
  _mergeRouteRecord(
  {
    path: '/landing',
    name: 'landing',
    component: () => import('/home/appforge/public_html/resources/ts/pages/landing.vue'),
    /* no children */
  },
  _definePage_default_8
  ),
  {
    path: '/lead',
    /* internal name: 'lead' */
    /* no component */
    children: [
      {
        path: ':appId',
        /* internal name: 'lead-app-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':slug',
            name: 'lead-app-id-slug',
            component: () => import('/home/appforge/public_html/resources/ts/pages/lead/[appId]/[slug].vue'),
            /* no children */
          },
  _definePage_default_9
  )
        ],
      }
    ],
  },
  {
    path: '/legal',
    /* internal name: 'legal' */
    /* no component */
    children: [
      {
        path: ':appId',
        /* internal name: 'legal-app-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':type',
            name: 'legal-app-id-type',
            component: () => import('/home/appforge/public_html/resources/ts/pages/legal/[appId]/[type].vue'),
            /* no children */
          },
  _definePage_default_10
  )
        ],
      },
      {
        path: 'platform',
        /* internal name: 'legal-platform' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':type',
            name: 'legal-platform-type',
            component: () => import('/home/appforge/public_html/resources/ts/pages/legal/platform/[type].vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/appforge/public_html/resources/ts/pages/login.vue'),
    /* no children */
  },
  _definePage_default_12
  ),
  {
    path: '/modules',
    /* internal name: 'modules' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':slug',
        name: 'modules-slug',
        component: () => import('/home/appforge/public_html/resources/ts/pages/modules/[slug].vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  {
    path: '/newsletter',
    /* internal name: 'newsletter' */
    /* no component */
    children: [
      {
        path: 'unsubscribe',
        /* internal name: 'newsletter-unsubscribe' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':token',
            name: 'newsletter-unsubscribe-token',
            component: () => import('/home/appforge/public_html/resources/ts/pages/newsletter/unsubscribe/[token].vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/appforge/public_html/resources/ts/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_15
  ),
  {
    path: '/pages',
    /* internal name: 'pages' */
    /* no component */
    children: [
      {
        path: 'account-settings',
        /* internal name: 'pages-account-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-account-settings-tab',
            component: () => import('/home/appforge/public_html/resources/ts/pages/pages/account-settings/[tab].vue'),
            /* no children */
          },
  _definePage_default_16
  )
        ],
      },
      {
        path: 'authentication',
        /* internal name: 'pages-authentication' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'reset-password-v1',
            name: 'pages-authentication-reset-password-v1',
            component: () => import('/home/appforge/public_html/resources/ts/pages/pages/authentication/reset-password-v1.vue'),
            /* no children */
          },
  _definePage_default_17
  )
        ],
      }
    ],
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('/home/appforge/public_html/resources/ts/pages/portfolio.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/prezzi',
    name: 'prezzi',
    component: () => import('/home/appforge/public_html/resources/ts/pages/prezzi.vue'),
    /* no children */
  },
  _definePage_default_18
  ),
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/home/appforge/public_html/resources/ts/pages/register.vue'),
    /* no children */
  },
  _definePage_default_19
  ),
  {
    path: '/settings',
    /* internal name: 'settings' */
    /* no component */
    children: [
      {
        path: 'backend-smtp',
        name: 'settings-backend-smtp',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/backend-smtp.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-backend-smtp",
          "layout": "default"
        }
      },
      {
        path: 'backend-user-notifications',
        name: 'settings-backend-user-notifications',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/backend-user-notifications.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-backend-user-notifications",
          "layout": "default"
        }
      },
      {
        path: 'backend-whatsender',
        name: 'settings-backend-whatsender',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/backend-whatsender.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-backend-whatsender",
          "layout": "default"
        }
      },
      {
        path: 'google-maps',
        name: 'settings-google-maps',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/google-maps.vue'),
        /* no children */
      },
      {
        path: 'guides',
        /* internal name: 'settings-guides' */
        /* no component */
        children: [
          {
            path: 'api-management',
            name: 'settings-guides-api-management',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/api-management.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-api-management"
            }
          },
          {
            path: 'attendance',
            name: 'settings-guides-attendance',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/attendance.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-attendance"
            }
          },
          {
            path: 'book-catalog',
            name: 'settings-guides-book-catalog',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/book-catalog.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-book-catalog"
            }
          },
          {
            path: 'communications-hub',
            name: 'settings-guides-communications-hub',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/communications-hub.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-communications-hub"
            }
          },
          {
            path: 'community-hub',
            name: 'settings-guides-community-hub',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/community-hub.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-community-hub"
            }
          },
          {
            path: 'coupon-rush',
            name: 'settings-guides-coupon-rush',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/coupon-rush.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-coupon-rush"
            }
          },
          {
            path: 'custom-html',
            name: 'settings-guides-custom-html',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/custom-html.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-custom-html"
            }
          },
          {
            path: 'custom-page',
            name: 'settings-guides-custom-page',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/custom-page.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-custom-page"
            }
          },
          {
            path: 'digital-signage',
            name: 'settings-guides-digital-signage',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/digital-signage.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-digital-signage"
            }
          },
          {
            path: 'ecommerce',
            name: 'settings-guides-ecommerce',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/ecommerce.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-ecommerce"
            }
          },
          {
            path: 'folder',
            name: 'settings-guides-folder',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/folder.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-folder"
            }
          },
          {
            path: 'forms',
            name: 'settings-guides-forms',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/forms.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-forms"
            }
          },
          {
            path: 'funnel',
            name: 'settings-guides-funnel',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/funnel.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-funnel"
            }
          },
          {
            path: 'gallery',
            name: 'settings-guides-gallery',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/gallery.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-gallery"
            }
          },
          {
            path: 'games',
            name: 'settings-guides-games',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/games.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-games"
            }
          },
          {
            path: 'loyalty',
            name: 'settings-guides-loyalty',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/loyalty.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-loyalty"
            }
          },
          {
            path: 'mobile-app',
            name: 'settings-guides-mobile-app',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/mobile-app.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-mobile-app"
            }
          },
          {
            path: 'nutritionist',
            name: 'settings-guides-nutritionist',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/nutritionist.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-nutritionist"
            }
          },
          {
            path: 'popup',
            name: 'settings-guides-popup',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/popup.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-popup"
            }
          },
          {
            path: 'profinder',
            name: 'settings-guides-profinder',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/profinder.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-profinder"
            }
          },
          {
            path: 'promo-coupon',
            name: 'settings-guides-promo-coupon',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/promo-coupon.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-promo-coupon"
            }
          },
          {
            path: 'radio',
            name: 'settings-guides-radio',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/radio.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-radio"
            }
          },
          {
            path: 'referral',
            name: 'settings-guides-referral',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/referral.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-referral"
            }
          },
          {
            path: 'reseller-api',
            name: 'settings-guides-reseller-api',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/reseller-api.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-reseller-api"
            }
          },
          {
            path: 'ride-hailing',
            name: 'settings-guides-ride-hailing',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/ride-hailing.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-ride-hailing"
            }
          },
          {
            path: 'salon',
            name: 'settings-guides-salon',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/salon.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-salon"
            }
          },
          {
            path: 'scratch-win',
            name: 'settings-guides-scratch-win',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/scratch-win.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-scratch-win"
            }
          },
          {
            path: 'shared-documents',
            name: 'settings-guides-shared-documents',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/shared-documents.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-shared-documents"
            }
          },
          {
            path: 'shopify-sync',
            name: 'settings-guides-shopify-sync',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/shopify-sync.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-shopify-sync"
            }
          },
          {
            path: 'webview',
            name: 'settings-guides-webview',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/webview.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-webview"
            }
          },
          {
            path: 'wordpress',
            name: 'settings-guides-wordpress',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/wordpress.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-book-catalog"
            }
          },
          {
            path: 'xdelivery',
            name: 'settings-guides-xdelivery',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/guides/xdelivery.vue'),
            /* no children */
            meta: {
              "navActiveLink": "settings-guides-xdelivery"
            }
          }
        ],
      },
      {
        path: 'languages',
        /* internal name: 'settings-languages' */
        /* no component */
        children: [
          {
            path: '',
            name: 'settings-languages',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/languages/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'settings-languages-id',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/languages/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'legal',
        /* internal name: 'settings-legal' */
        /* no component */
        children: [
          {
            path: 'cookies',
            name: 'settings-legal-cookies',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/legal/cookies.vue'),
            /* no children */
          },
          {
            path: 'LegalPageEditor',
            name: 'settings-legal-legal-page-editor',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/legal/LegalPageEditor.vue'),
            /* no children */
          },
          {
            path: 'privacy',
            name: 'settings-legal-privacy',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/legal/privacy.vue'),
            /* no children */
          },
          {
            path: 'terms',
            name: 'settings-legal-terms',
            component: () => import('/home/appforge/public_html/resources/ts/pages/settings/legal/terms.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'mobile-app',
        name: 'settings-mobile-app',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/mobile-app.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-mobile-app",
          "layout": "default"
        }
      },
      {
        path: 'modules',
        name: 'settings-modules',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/modules.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-modules",
          "layout": "default"
        }
      },
      {
        path: 'onesignal',
        name: 'settings-onesignal',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/onesignal.vue'),
        /* no children */
      },
      {
        path: 'payment-gateways',
        name: 'settings-payment-gateways',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/payment-gateways.vue'),
        /* no children */
      },
      {
        path: 'reseller-provisioning',
        name: 'settings-reseller-provisioning',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/reseller-provisioning.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-reseller-provisioning",
          "layout": "default"
        }
      },
      {
        path: 'smtp',
        name: 'settings-smtp',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/smtp.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-smtp",
          "layout": "default"
        }
      },
      {
        path: 'social',
        name: 'settings-social',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/social.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-social"
        }
      },
      {
        path: 'subscription',
        name: 'settings-subscription',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/subscription.vue'),
        /* no children */
        meta: {
          "allowedRoles": [
            "client"
          ]
        }
      },
      {
        path: 'system-notification-templates',
        name: 'settings-system-notification-templates',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/system-notification-templates.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-system-notification-templates",
          "layout": "default"
        }
      },
      {
        path: 'team',
        name: 'settings-team',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/team.vue'),
        /* no children */
      },
      {
        path: 'token',
        name: 'settings-token',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/token.vue'),
        /* no children */
      },
      {
        path: 'whatsender',
        name: 'settings-whatsender',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/whatsender.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-whatsender",
          "layout": "default"
        }
      },
      {
        path: 'whitelabel',
        name: 'settings-whitelabel',
        component: () => import('/home/appforge/public_html/resources/ts/pages/settings/whitelabel.vue'),
        /* no children */
        meta: {
          "navActiveLink": "settings-whitelabel",
          "layout": "default"
        }
      }
    ],
  },
  {
    path: '/soluzioni',
    /* internal name: 'soluzioni' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':slug',
        name: 'soluzioni-slug',
        component: () => import('/home/appforge/public_html/resources/ts/pages/soluzioni/[slug].vue'),
        /* no children */
      },
  _definePage_default_20
  )
    ],
  },
  {
    path: '/tools',
    /* internal name: 'tools' */
    /* no component */
    children: [
      {
        path: 'screenshot-generator',
        name: 'tools-screenshot-generator',
        component: () => import('/home/appforge/public_html/resources/ts/pages/tools/screenshot-generator.vue'),
        /* no children */
        meta: {
          "navActiveLink": "tools-screenshot-generator",
          "layout": "default"
        }
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/under-maintenance',
    name: 'under-maintenance',
    component: () => import('/home/appforge/public_html/resources/ts/pages/under-maintenance.vue'),
    /* no children */
  },
  _definePage_default_21
  )
]
